import DataTable, { useDataTableHandle } from './DataTable';
export default DataTable;
export { useDataTableHandle };
